import $ from 'jquery';

$(document).ready(function(){

    $('.ginput_container_fileupload').each((i, el) => {

        const uploadButton = $(el).parent().find('.btn--file-upload-trigger');
        const uploadButtonTarget = uploadButton.attr('data-target');
        const fileInfo = $(el).parent().find('.gfield_description');
        const realInput = $('#' + uploadButtonTarget);

        uploadButton.on('click', (e) => {
            e.preventDefault();
            realInput.click();
        });

        realInput.on('change', (e) => {
            const name = e.target.value.split(/\\|\//).pop();
            const truncated = name.length > 20
                ? name.substr(name.length - 20)
                : name;

            fileInfo[0].innerHTML = truncated;
        });
    });

});

